var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _path10, _path11, _path12, _rect2, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 342.89 85.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.47,68.13V14.85h10.66v22.18h20.09V14.85h10.73v53.28h-10.73v-21.53h-20.09v21.53h-10.66Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.14,68.49c-3.17,0-5.88-.32-8.14-.97-2.26-.65-4.09-1.74-5.51-3.28-1.42-1.54-2.45-3.58-3.1-6.12-.65-2.54-.97-5.69-.97-9.43,0-3.94.32-7.19.97-9.76.65-2.57,1.68-4.58,3.1-6.05,1.42-1.46,3.26-2.5,5.54-3.1,2.28-.6,4.98-.9,8.1-.9s5.95.31,8.21.94c2.25.62,4.09,1.67,5.51,3.13,1.42,1.46,2.45,3.48,3.1,6.05.65,2.57.97,5.8.97,9.68s-.31,7.04-.94,9.61c-.62,2.57-1.63,4.6-3.02,6.08-1.39,1.49-3.23,2.54-5.51,3.17-2.28.62-5.05.94-8.32.94ZM159.14,59.99c1.3,0,2.39-.12,3.28-.36.89-.24,1.61-.73,2.16-1.48.55-.74.97-1.88,1.26-3.42.29-1.54.43-3.55.43-6.05s-.14-4.57-.43-6.08c-.29-1.51-.71-2.64-1.26-3.38-.55-.74-1.27-1.23-2.16-1.48-.89-.24-1.98-.36-3.28-.36s-2.32.12-3.2.36c-.89.24-1.62.73-2.2,1.48-.58.75-1,1.87-1.26,3.38-.26,1.51-.4,3.54-.4,6.08s.13,4.51.4,6.05c.26,1.54.68,2.68,1.26,3.42.58.75,1.31,1.24,2.2,1.48.89.24,1.96.36,3.2.36Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M196.08,68.27c-2.74,0-5-.44-6.8-1.33-1.8-.89-3.13-2.26-4-4.1-.86-1.85-1.3-4.24-1.3-7.16V13.19h10.66v40.9c0,1.44.14,2.58.43,3.42s.73,1.45,1.33,1.84c.6.38,1.36.65,2.27.79l2.95.43v7.7h-5.54Z",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M207.81,23.78c-1.01,0-1.51-.48-1.51-1.44v-7.06c0-1.01.5-1.51,1.51-1.51h8.21c.43,0,.77.14,1.01.43.24.29.36.65.36,1.08v7.06c0,.96-.46,1.44-1.37,1.44h-8.21ZM206.52,68.13V29.46h10.66v38.66h-10.66Z",
    fill: "currentcolor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M238.05,68.56c-3.02,0-5.57-.64-7.63-1.91-2.06-1.27-3.61-3.33-4.64-6.19-1.03-2.86-1.55-6.61-1.55-11.27s.44-8.69,1.33-11.66c.89-2.98,2.39-5.16,4.5-6.55,2.11-1.39,5.02-2.09,8.71-2.09,1.78,0,3.53.18,5.26.54,1.73.36,3.26.78,4.61,1.26V13.19h10.73v54.94h-9l-1.73-3.67c-.82.77-1.81,1.46-2.99,2.09-1.18.62-2.41,1.12-3.71,1.48-1.3.36-2.59.54-3.89.54ZM241.8,59.99c1.44,0,2.75-.24,3.92-.72,1.18-.48,2.15-.96,2.92-1.44v-19.44c-.96-.34-1.97-.67-3.02-1.01-1.06-.33-2.18-.5-3.38-.5-1.78,0-3.2.31-4.28.94-1.08.62-1.86,1.79-2.34,3.49-.48,1.7-.72,4.16-.72,7.38,0,2.98.23,5.29.68,6.95s1.19,2.8,2.2,3.42c1.01.62,2.35.94,4.03.94Z",
    fill: "currentcolor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275.57,68.56c-2.93,0-5.3-.86-7.13-2.59-1.83-1.73-2.74-4.13-2.74-7.2v-3.46c0-2.93,1.03-5.34,3.1-7.24,2.06-1.9,5.28-2.84,9.65-2.84h9.86v-2.66c0-1.2-.22-2.2-.65-2.99s-1.24-1.37-2.41-1.73c-1.18-.36-2.96-.54-5.36-.54h-11.59v-6.19c1.87-.58,4.04-1.08,6.52-1.51,2.47-.43,5.46-.65,8.96-.65,3.21,0,5.96.38,8.24,1.15,2.28.77,4.01,2.09,5.18,3.96,1.18,1.87,1.76,4.46,1.76,7.78v26.28h-8.42l-1.73-4.1c-.34.38-.91.82-1.73,1.3-.82.48-1.81.97-2.99,1.48-1.18.5-2.5.92-3.96,1.26s-2.99.5-4.57.5ZM280.97,61.14c.48,0,1.02-.06,1.62-.18.6-.12,1.22-.26,1.87-.43.65-.17,1.25-.33,1.8-.5.55-.17,1.01-.32,1.37-.47.36-.14.59-.24.68-.29v-9l-6.48.43c-1.87.14-3.25.62-4.14,1.44-.89.82-1.33,1.92-1.33,3.31v1.58c0,.96.2,1.75.61,2.38.41.62.96,1.07,1.66,1.33.7.26,1.48.4,2.34.4Z",
    fill: "currentcolor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M319.05,85.19l4.18-17.06c-2.16,0-4.06-.41-5.69-1.22-1.63-.82-2.99-1.98-4.07-3.49-1.08-1.51-1.91-3.4-2.48-5.65l-7.27-28.3h11.09l6.12,26.14c.24.91.55,1.63.94,2.16.38.53.79.9,1.22,1.12.43.22.83.36,1.19.43.36.07.64.11.83.11l6.98-29.95h10.8l-11.52,48.6-3.46,7.13h-8.86Z",
    fill: "currentcolor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 33.83,
    width: 67,
    height: 8,
    fill: "currentcolor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4c0-2.21-1.79-4-4-4s-4,1.79-4,4v4h8v-4Z",
    fill: "currentcolor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24,25c2.21,0,4-1.79,4-4v-5h-8v5c0,2.21,1.79,4,4,4Z",
    fill: "currentcolor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75,16v17.83h8V12c0-2.21-1.79-4-4-4h-16v8h12Z",
    fill: "currentcolor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8,16h12v-8H4c-2.21,0-4,1.79-4,4v21.83h8v-17.83Z",
    fill: "currentcolor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75,73H8v-31.17H0v35.17c0,2.21,1.79,4,4,4h75c2.21,0,4-1.79,4-4v-35.17h-8v31.17Z",
    fill: "currentcolor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 8,
    width: 27,
    height: 8,
    fill: "currentcolor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63,4c0-2.21-1.79-4-4-4s-4,1.79-4,4v4h8v-4Z",
    fill: "currentcolor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59,25c2.21,0,4-1.79,4-4v-5h-8v5c0,2.21,1.79,4,4,4Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1f4308dc06f4043dad4571b309a8a8da.svg";
export { ForwardRef as ReactComponent };